/**
 * Slider Component
 *
 * @file slider.js
 */

 import $ from "jquery";
 import Swiper from 'swiper';
 import SwiperCore, { Navigation, Pagination, Autoplay, EffectCoverflow, EffectFade, Controller, Thumbs  } from 'swiper/core';
 SwiperCore.use([Navigation, Pagination, Autoplay, EffectCoverflow, EffectFade, Controller, Thumbs ]);
 
 import 'swiper/swiper-bundle.css';
 import 'swiper/swiper-bundle.min.js';
 import 'swiper/components/effect-coverflow/effect-coverflow.min.css';
 import 'swiper/components/effect-fade/effect-fade.min.css';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  
    const fullSlider = () => {
      let swiper2 = new Swiper('.main-slider', {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: ".hm-next",
          prevEl: ".hm-prev ",
        },
        autoplay: {
          delay: 6000,
        },
        speed:1200,
        noSwiping:true,
        allowTouchMove:false,
        watchSlidesProgress: true,
        loop:false,
        effect: "fade",
        breakpoints: {
          0: {
            noSwiping:false,
            allowTouchMove:true,
            calculateHeight:true,
            autoHeight:true,
          },
          680: {
            noSwiping:false,
            allowTouchMove:true,
            calculateHeight:true,
            autoHeight:true,
          },
          992: {
            noSwiping:true,
            allowTouchMove:false,
          },
          1000: {
            calculateHeight:false,
            autoHeight:false,
          },
        }
      });
      let swiper2Thumb = new Swiper(".swiper-tab-slide", {
        slidesPerView: 4,
        centeredSlides: true,
        slideToClickedSlide: true,
        loop:false, 
        speed:1200,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 4000,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          680: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 4,
          },
        }
      });
    };
    const homeProductCarousel = () => {
      const homeProductCarousel = new Swiper('.home-product-listing', {
          slidesPerView: 7.5,
          spaceBetween: 20,
          watchSlidesProgress: true,
          speed:700,
          navigation: {
            nextEl: ".hm-pr-car-arr .next",
            prevEl: ".hm-pr-car-arr .prev ",
          },
          breakpoints: {
            0: {
              slidesPerView: 2,
              allowTouchMove: true,
            },
            680: {
              slidesPerView: 3,
            },
            992: {
              slidesPerView: 3,
            },
            1000: {
              slidesPerView: 3.5,
            },
            1100: {
              slidesPerView: 4.5,
            },
            1300: {
              slidesPerView: 5.5,
            },
            1520: {
              slidesPerView: 7.5,
            },
          }
      });
    };

    const homeNewsCarousel = () => {
      const homeNewsCarousel = new Swiper('.home-news-carousel', {
          slidesPerView: 4.2,
          spaceBetween: 20,
          centeredSlides: true,
          loop:true,
          speed:700,
          navigation: {
            nextEl: ".hm-news-arr .next",
            prevEl: ".hm-news-arr .prev ",
          },
          breakpoints: {
            0: {
              spaceBetween: 15,
              slidesPerView: 1.2,
              allowTouchMove: true,
            },
            680: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 2.3,
            },
            1100: {
              slidesPerView: 3.3,
            },
            1520: {
              slidesPerView: 4.2,
            },
          }
      });
    };

    const productDetailThumbGallery = () => {
      const sliderThumbnail = new Swiper('.product-th-slide', {
        slidesPerView: 3.8,
        spaceBetween: 15,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        pagination: {
          el: ".sw-pagination",
          type: "progressbar",
        },
        navigation: {
          nextEl: ".sw-next",
          prevEl: ".sw-prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 2,
            allowTouchMove: true,
          },
          680: {
            slidesPerView: 4,
          },
          992: {
            slidesPerView: 3,
          },
          1100: {
            slidesPerView: 3.8,
          },
        }
      });

      const slider = new Swiper('.product-lt-slide', {
        thumbs: {
          swiper: sliderThumbnail
        }
      });
    };

    const productGeneralFeatures = () => {
      const productGeneralFeatures = new Swiper('.general-features-carousel', {
          slidesPerView: 3,
          spaceBetween: 40,
          watchSlidesProgress: true,
          loop:false,
          speed:700,
          navigation: {
            nextEl: ".hmt-arrow .next",
            prevEl: ".hmt-arrow .prev ",
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
              allowTouchMove: true,
            },
            680: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 2,
            },
            1100: {
              slidesPerView: 3,
            },
          }
      });
    };

    const optionGeneralFeatures = () => {
      const optionGeneralFeatures = new Swiper('.option-features-carousel', {
          slidesPerView: 3,
          spaceBetween: 40,
          watchSlidesProgress: true,
          loop:false,
          speed:700,
          navigation: {
            nextEl: ".hmt-w .next",
            prevEl: ".hmt-w .prev ",
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
              allowTouchMove: true,
            },
            680: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 2,
            },
            1100: {
              slidesPerView: 3,
            },
          }
      });
    };

    const productListCarousel = () => {
      let largeSliders = document.querySelectorAll('.category-list-carousel')
      let prevArrow = document.querySelectorAll('.category-carousel-arrow .prev')
      let nextArrow = document.querySelectorAll('.category-carousel-arrow .next')
      largeSliders.forEach((slider, index)=>{
        // this bit checks if there's more than 1 slide, if there's only 1 it won't loop
        let sliderLength = slider.children[0].children.length
        let result = (sliderLength > 1) ? true : false
        const swiper = new Swiper(slider, {
          slidesPerView: 3,
          spaceBetween: 40,
          watchSlidesProgress: true,
          loop:false,
          speed:700,
          navigation: {
            nextEl: nextArrow[index],
            prevEl: prevArrow[index],
          },
          speed: 1000,
          breakpoints: {
            0: {
              slidesPerView: 1,
              allowTouchMove: true,
              spaceBetween: 0,
            },
            680: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1100: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
          }
        });	
      });
    };



  const init = () => {
    fullSlider();
    homeProductCarousel();
    homeNewsCarousel();
    productDetailThumbGallery();
    productGeneralFeatures();
    optionGeneralFeatures();
    productListCarousel();
  };

  return {
    init,
  };
})();

export default slider;
